import React, { useContext, useEffect, useState } from 'react';
import { ChevronDown, ChevronUp, Info, Mail, User } from 'react-feather';
import { WorkflowContext } from './ActiveWorkflowsPage';
import ProgressBar from '../../components/Input/ProgressBar';
import ProfileImage from '../../components/ProfileImage';
import WorkflowComplianceActionRow from './WorkflowComplianceActionRow';
import FlexWrapper from '../FlexWrapper';
import ExpandableTableRow from '../../components/Table/ExpandableTableRow';
import Table from '../../components/Table/Table';
import "./WorkflowComplianceActions.scss";
import Button from '../../components/Buttons/Button';
import SpotCheckRejectionModal from '../../components/Modals/SpotCheckRejectionModal';
import SpotCheckApprovalModal from '../../components/Modals/SpotCheckApprovalModal';
import { useRemote, useStorage } from '../../Utils/Utils';
import { toastDanger, toastSuccess } from '../../components/popups/Toast';
import { useHistory } from 'react-router-dom';

const WorkflowComplianceSpotCheckRow = ({ refreshList, step, idx, taskId, setApproversList, historical, workflowId }) => {
	const remote = useRemote()
	const storage = useStorage()
	const history = useHistory();

	const [rowSelected, setRowSelected] = useState(false)
	const [showRejectionModal, setShowRejectionModal] = useState(false)
	const [showApprovalModal, setShowApprovalModal] = useState(false)
	const [me, setMe] = useState(null)

	useEffect(() => {
		storage.getOrFetch("/crm/me").then(setMe)
	}, [])


	const handleRestartWorkflow = async () => {
		try {
			await remote.post(`workflows/workflow/restart/${workflowId}`);
			setShowRejectionModal(false);
			history.push("/active-workflows");
			toastSuccess("Workflow restarted successfully.");
		} catch (error) {
			console.error("Failed to restart workflow:", error);
			toastDanger("Failed to restart workflow. Please try again later.");
		}
	};

	const handleCancelWorkflow = async () => {
		try {
			await remote.delete(`workflows/workflow/${workflowId}`);
			setShowRejectionModal(false);
			history.push("/active-workflows");
			toastSuccess("Workflow cancelled successfully.");
		} catch (error) {
			console.error("Failed to delete workflow:", error);
			toastDanger("Failed to cancel workflow. Please try again later.");
		}
	};

	const handleApproveWorkflow = async () => {
		try {
			await remote.post(`/workflows/workflow/review/spot/${workflowId}/approve`);
			setShowApprovalModal(false);
			toastSuccess("Workflow approved successfully.");
		} catch (error) {
			console.error("Failed to approve workflow:", error);
			toastDanger("Failed to approve workflow. Please try again later.");
		}
	}

	const hasPermission = me && step.approversAvailable && step.approversAvailable.some(approver => approver.email === me.email);
	const totalFunds = step.totalData
	const completedFunds = step.datas ? step.datas.filter(f => f.status === "Approved").length : 0
	const content = [
		<FlexWrapper gap='s'>
			{step.name}
		</FlexWrapper>,
		<FlexWrapper >
			{Array.from({ length: step.approversNeeded }).map((_, index) => (
				<User key={index} color="#0E8EFD" />
			))}
		</FlexWrapper>,
		<FlexWrapper >
			{step.approversAvailable.map((approver, idx) => {
				if (idx > 3) return null
				return <ProfileImage onClick={(e) => { e.stopPropagation(); setApproversList(step.approversAvailable) }} style={idx > 0 ? { marginLeft: "-0.25rem", border: "white 1px solid", cursor: "pointer" } : {}} user={approver} />
			})}
			{step.approversAvailable.length > 4 && <p onClick={(e) => { e.stopPropagation(); setApproversList(step.approversAvailable) }} className='extension-label ml-s pointer'>{`+${step.approversAvailable.length - 4} more`}</p>}
		</FlexWrapper>,
		`${completedFunds}/${totalFunds}`,
		<ProgressBar extent={totalFunds} value={completedFunds} colour1={totalFunds === completedFunds ? "#E0FFF6" : null} colour2={totalFunds === completedFunds ? "#56D1C3" : null} />,
		<FlexWrapper align="center" justify='right' gap="l" fullWidth className="pl-l">
			<FlexWrapper gap="m" >
				{hasPermission &&
					<>
						<Button onClick={(e) => { e.stopPropagation(); setShowApprovalModal(true) }} variant="positive">Approve</Button>
						<Button onClick={(e) => { e.stopPropagation(); setShowRejectionModal(true) }} variant="danger">Reject</Button>
					</>
				}
			</FlexWrapper>
		</FlexWrapper>
	]

	const closeSelectedRow = () => {
		setRowSelected(false)
	}

	const groupDataMap = step && step.groupStatus.map((group, idx) => {
		return <tr >
			<td colSpan={7}>{`${group.offerName} (${group.total})`}</td>
		</tr>
	})
	const groupTable = <Table dataMap={groupDataMap} minWidth={1000} />

	return (
		<>
			<SpotCheckApprovalModal isOpen={showApprovalModal} handleClose={() => setShowApprovalModal(false)} handleApprove={handleApproveWorkflow} documentCount={step.totalData} />
			<SpotCheckRejectionModal isOpen={showRejectionModal} handleClose={() => setShowRejectionModal(false)} handleRestart={handleRestartWorkflow} handleCancelWorkflow={handleCancelWorkflow} documentCount={step.totalData} />
			<ExpandableTableRow expandRowClassname="workflow-step-expansion" className='workflow-compliance-step-row pointer' expandContent={groupTable} onClick={() => { !rowSelected ? setRowSelected(true) : closeSelectedRow() }} numberOfCols={historical ? 6 : 7} >
				<td><FlexWrapper align="center" >{content[0]}</FlexWrapper></td>
				<td>{content[1]}</td>
				{historical ? "" : <td>{content[2]}</td>}
				<td>{content[3]}</td>
				<td className='pr-m' >{content[4]}</td>
				<td>{content[5]}</td>
				<td className='workflow-cell-align-right action-row-hoverable-chevron'>{rowSelected ? <ChevronUp color="#0E8EFD" /> : <ChevronDown color="#C2C4CE" />}</td>
			</ExpandableTableRow>
		</>
	);
}

export default WorkflowComplianceSpotCheckRow;